import { CandidatesConst } from '@axiom/const';
import { ProgressSteps, ProgressStepsItem } from '@axiom/ui';
import type { Account, AfcSubmission } from '@axiom/validation';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useEngagementInterviewTalentData } from '../../hooks/useEngagementInterviewTalentData';
import { useEngagementTalentData } from '../../hooks/useEngagementTalentData';

export const ProgressLabel = {
  matches: 'Matches',
  interviewing: 'Interviewing',
  contracting: 'Contracting',
  engaged: 'Engaged',
} as const;

export const MyEngagementsProcessSteps = ({
  submission,
}: {
  submission?: AfcSubmission;
}) => {
  const { submissionId: urlSubmissionId, accountId: urlAccountId } =
    useParams();

  const { interviewCount } = useEngagementInterviewTalentData({
    submissionId: urlSubmissionId,
  });

  const { matchesCount, instantMatches } = useEngagementTalentData({
    account: { id: urlAccountId } as Account,
    submissionId: urlSubmissionId,
  });

  const progressStatus = () => {
    const candidateOpps =
      submission?.positions[0]?.candidateOpportunities ?? [];
    const hasEngaged = candidateOpps.find(
      co => co.candidateStatus === CandidatesConst.CandidateStatuses.Engaged
    );
    const hasSelected = candidateOpps.find(
      co => co.candidateStatus === CandidatesConst.CandidateStatuses.Selected
    );
    const hasInterviewing = interviewCount > 0;
    const hasMatches =
      matchesCount > 0 || instantMatches.some(match => match.passed);
    if (hasEngaged) {
      return ProgressLabel.engaged;
    } else if (hasSelected) {
      return ProgressLabel.contracting;
    } else if (hasInterviewing) {
      return ProgressLabel.interviewing;
    } else if (hasMatches) {
      return ProgressLabel.matches;
    }
    return null;
  };

  return (
    <ProgressSteps
      direction="horizontal"
      icon="checkmark"
      completedStep={progressStatus()}
      name="engagement-progress-steps"
    >
      <ProgressStepsItem stepName={ProgressLabel.matches}>
        {ProgressLabel.matches}
      </ProgressStepsItem>
      <ProgressStepsItem stepName={ProgressLabel.interviewing}>
        {ProgressLabel.interviewing}
      </ProgressStepsItem>
      <ProgressStepsItem stepName={ProgressLabel.contracting}>
        {ProgressLabel.contracting}
      </ProgressStepsItem>
      <ProgressStepsItem stepName={ProgressLabel.engaged}>
        {ProgressLabel.engaged}
      </ProgressStepsItem>
    </ProgressSteps>
  );
};
